import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary via-primary/90 to-accent/80">
      {/* Gradient Overlays */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,_hsl(var(--accent)/0.15),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,_hsl(var(--primary)/0.2),transparent_60%)]" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-10">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full text-primary-foreground font-semibold border border-white/20 mb-4 animate-fade-in">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
            <span>Empowering 9.4M People with Criminal Records</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-primary-foreground leading-tight animate-fade-in">
            Everyone Deserves a<br />
            <span className="text-accent drop-shadow-lg">
              Second Chance
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-primary-foreground/95 max-w-3xl mx-auto leading-relaxed backdrop-blur-sm bg-white/5 rounded-2xl p-6">
            Connecting 9.4 million people with criminal records to employers who believe in skills, potential, and redemption.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="shadow-[var(--shadow-elevated)] hover-scale bg-white text-primary hover:bg-white/95 font-semibold h-14 px-8 text-lg">
              <Link to="/job-search">
                Find Your Next Opportunity
              </Link>
            </Button>
            <Button asChild size="lg" variant="secondary" className="shadow-[var(--shadow-card)] hover-scale bg-white/10 text-primary-foreground border-white/30 hover:bg-white/20 h-14 px-8 text-lg backdrop-blur-sm">
              <Link to="/ai-resume-builder">
                Build AI Resume
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="bg-white/95 text-foreground border-0 hover:bg-white shadow-[var(--shadow-card)] hover-scale h-14 px-8 text-lg">
              <Link to="/auth?context=employer">
                I'm an Employer
              </Link>
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20 pt-16 border-t border-primary-foreground/20">
            <div className="space-y-3 backdrop-blur-sm bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all hover-scale">
              <div className="text-5xl md:text-6xl font-bold text-accent drop-shadow-lg">9.4M</div>
              <div className="text-primary-foreground/95 text-lg font-medium">Working-Age People<br />with Criminal Records</div>
            </div>
            <div className="space-y-3 backdrop-blur-sm bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all hover-scale">
              <div className="text-5xl md:text-6xl font-bold text-accent drop-shadow-lg">45%</div>
              <div className="text-primary-foreground/95 text-lg font-medium">Target Employment Rate<br />Within 12 Months</div>
            </div>
            <div className="space-y-3 backdrop-blur-sm bg-white/5 rounded-2xl p-6 hover:bg-white/10 transition-all hover-scale">
              <div className="text-5xl md:text-6xl font-bold text-accent drop-shadow-lg">£62M+</div>
              <div className="text-primary-foreground/95 text-lg font-medium">Annual Cost Savings<br />Through Reduced Reoffending</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
